import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { authApiIsomorphicCheckResetPasswordToken } from '#/modules/auth/api/authApiCheckResetPasswordToken';
import { authResetPasswordRoute } from '#/modules/auth/routing/auth.routes';
import { HORIZON_ENABLED } from '#/rendering/state/renderingState';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import { invalidOrExpiredLinkRoute } from '#/routing/routes';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { idealistRedirect } from '#/routing/utils/idealistRedirect';

import { AuthResetPasswordPageLoadable } from './AuthResetPasswordPageLoadable';

export async function loader({
  request,
  context,
  params: { token },
}: HorizonAppRouteLoaderArgs<typeof authResetPasswordRoute>) {
  if (!HORIZON_ENABLED) return;

  const [tokenAvailable] = await Promise.all([
    authApiIsomorphicCheckResetPasswordToken({ request, context })(token)
      .then(() => true)
      .catch(() => false),
    AuthResetPasswordPageLoadable.load(),
  ]);

  if (!tokenAvailable) {
    return idealistRedirect({
      request,
      context,
      to: invalidOrExpiredLinkRoute.with({}),
    });
  }
}

export default function AuthResetPasswordHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Reset Password')}>
      <AuthResetPasswordPageLoadable />
    </RouteModule>
  );
}
